import GoalsComponent from '../GoalsComponent.vue'

export default [
    {
        path: '/goals',
        name: 'Goals',
        meta: { layout: 'default' },
        component: GoalsComponent,
    },
]